// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hOoX","placeholdersHeader":"styles_placeholdersHeader__2MJca","editorStyle":"styles_editorStyle__a2CVT","placeholdersBox":"styles_placeholdersBox__3XRE3"};